import { TransactionEntity } from "@goodfill/domain-entities";
import {
  asTransactionId,
  asBalanceAccountId,
  asAccountId,
  asAmount,
  asOrderTicketId,
  asTradeTicketId,
} from "@goodfill/domain-properties";
import Decimal from "decimal.js";
import { Transaction } from "../API";
import { createDateTimeFromAwsDateTime } from "../date/awsDateTimeFormat";
import { assertIsDecimalFinite } from "../number/assertIsDecimalFinite";

export function transactionApiToModel(
  apiTransaction: Transaction
): TransactionEntity {
  const balance = new Decimal(apiTransaction.balance);
  assertIsDecimalFinite(balance, apiTransaction.balance);

  const disponibleBalance = new Decimal(apiTransaction.disponibleBalance);
  assertIsDecimalFinite(disponibleBalance, apiTransaction.disponibleBalance);

  const amountChange = new Decimal(apiTransaction.amountChange);
  assertIsDecimalFinite(amountChange, apiTransaction.amountChange);

  const disponibleAmountChange = new Decimal(
    apiTransaction.disponibleAmountChange
  );
  assertIsDecimalFinite(
    disponibleAmountChange,
    apiTransaction.disponibleAmountChange
  );

  return {
    id: asTransactionId(apiTransaction.id),
    order: apiTransaction.order,
    balanceAccountId: asBalanceAccountId(apiTransaction.balanceAccountId),
    accountId: asAccountId(apiTransaction.accountId),
    previousTransactionId:
      apiTransaction.previousTransactionId !== null &&
      apiTransaction.previousTransactionId !== undefined
        ? asTransactionId(apiTransaction.previousTransactionId)
        : null,
    complementaryTransactionId:
      apiTransaction.complementaryTransactionId !== null &&
      apiTransaction.complementaryTransactionId !== undefined
        ? asTransactionId(apiTransaction.complementaryTransactionId)
        : null,
    transactedAt: createDateTimeFromAwsDateTime(
      apiTransaction.transactedAt,
      "apiBond.transactedAt"
    ),
    balance: asAmount(new Decimal(apiTransaction.balance)),
    disponibleBalance: asAmount(new Decimal(apiTransaction.disponibleBalance)),
    amountChange: asAmount(new Decimal(apiTransaction.amountChange)),
    disponibleAmountChange: asAmount(
      new Decimal(apiTransaction.disponibleAmountChange)
    ),
    orderTicketId:
      apiTransaction.orderTicketId !== null &&
      apiTransaction.orderTicketId !== undefined
        ? asOrderTicketId(apiTransaction.orderTicketId)
        : null,
    tradeTicketId:
      apiTransaction.tradeTicketId != null &&
      apiTransaction.tradeTicketId !== undefined
        ? asTradeTicketId(apiTransaction.tradeTicketId)
        : null,
    source: apiTransaction.source ?? null,
    type: apiTransaction.type,
  };
}
